import { ActivatedRoute } from '@angular/router';
import { Category } from 'src/app/model/Category';
import { CategoryService } from 'src/app/services/categories.services';
import { Component, OnInit } from '@angular/core';
import { CreationComponentInterface } from 'src/app/components/componentCreation/creation.component';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: '../../../../components/common/templates/create.component.html',
  styleUrls: ['../../../../styles/main.scss'],
  providers: [CategoryService]
})
export class CreateCategoryComponent implements OnInit, CreationComponentInterface {
  buttonPosition: any;
  columns: any;
  data: any;
  formantView: number;
  id: any;
  instance: Partial<Category>;
  rules: any;
  title: string;
  validateInputs: boolean;

  constructor(
    private categoryService: CategoryService,
    private location: Location,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private translate: TranslateService,
  ) {
    this.id = this.route.snapshot.queryParamMap.get('id');
    if (this.id) {
      this.title = 'update_category';
      this.categoryService.getByOne(this.id).subscribe((data) => {
        this.instance = data.data;
      });
    } else {
      this.title = 'create_category';
    }
  }

  async ngOnInit() {
    this.columns = [
      {
        name: 'name',
        type: 'input',
      },
      {
        name: 'seo',
        type: 'input',
      },
    ];
  }

  save(data: Partial<Category>) {
    if (!this.id) {
      this.categoryService.save(data).subscribe(category => {
        this.toastr.success(this.translate.instant('category_created'));
        this.location.back();
      }, (error) => this.toastr.error(error.message));
    } else {
      this.categoryService.update(this.id, data).subscribe(category => {
        this.toastr.success(this.translate.instant('updated_category'));
        this.location.back();
      }, (error) => this.toastr.error(error.message));
    }
  }
}
